import {
    GET_AGENT_REFERENCE_DATA_VALUE,
    GET_BANKS_REFERENCE_DATA_VALUE,
    GET_BRANCH_CODES_REFERENCE_DATA_VALUE,
    setKmfApiDetails,
    setKmfReferenceDetailsValue,
} from '../../../actions/kaMetlhaFuneralCover/referenceData';
import axios from 'axios';
import { API_CALL_STATUS } from '../../../reducers/status';

export const referenceDataService = (store, next, action) => {
    const result = next(action);
    if (action.type === GET_BANKS_REFERENCE_DATA_VALUE) {
        (async () => {
            const bankReferenceData = await fetchBankReferenceData();
            if (bankReferenceData) {
                store.dispatch(setKmfReferenceDetailsValue({value:bankReferenceData.data,fieldType:'banks'}));
            } else {
                store.dispatch(setKmfApiDetails({status:API_CALL_STATUS.FAILURE,name:'banksService'}));
            }
        })();
    }
    if (action.type === GET_BRANCH_CODES_REFERENCE_DATA_VALUE) {
        (async () => {
            store.dispatch(setKmfApiDetails({status:API_CALL_STATUS.PENDING,name:'branchCodesService'}));
            const branchCodesReferenceData = await fetchBranchCodesReferenceData(action.value);
            if (branchCodesReferenceData) {
                store.dispatch(setKmfReferenceDetailsValue({value:branchCodesReferenceData.data,fieldType:'branchCodes'}));
                store.dispatch(setKmfApiDetails({status:API_CALL_STATUS.SUCCESS,name:'branchCodesService'}));
            } else {
                store.dispatch(setKmfApiDetails({status:API_CALL_STATUS.FAILURE,name:'branchCodesService'}));
            }
        })();
    }
    if (action.type === GET_AGENT_REFERENCE_DATA_VALUE) {
    (async () => {
        store.dispatch(setKmfApiDetails({ status: API_CALL_STATUS.PENDING, name: 'agentService' }));
        const agentReferenceData = await agentService(action.value);
        if (agentReferenceData) {
            store.dispatch(setKmfReferenceDetailsValue({
                value: agentReferenceData,
                fieldType: 'agentInfo'
            }));
            store.dispatch(setKmfApiDetails({ status: API_CALL_STATUS.SUCCESS, name: '' }));
        } else {
            store.dispatch(setKmfApiDetails({ status: API_CALL_STATUS.FAILURE, name: '' }));
        }
    })();
}
    return result;
};

const fetchBankReferenceData = async () => {
    try {
        const response = await axios.get('/om-api/ka-metlha-funeral//banksBw', {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'Access-Control-Allow-Origin': '*',
            },
        });
        return response;
    } catch (error) {
        console.log(error);
        return null;
    }
};
const fetchBranchCodesReferenceData = async (bankCode) => {
    try {
        const response = await axios({
            url: `/om-api/ka-metlha-funeral/bankBranchBw/${bankCode}`,
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'Access-Control-Allow-Origin': 'null',
            },
        });
        return response;
    } catch (error) {
        return null;
    }
};
export const agentService = async (agentCode) => {
    const url = `/om-api/ka-metlha-funeral/getAgent/${agentCode}`;
    try {
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        return null;
    }
};
